module.exports = __webpack_public_path__ + "img/yello.800919ff.png";